import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  MicrosoftComplianceRecordingPolicyFieldConfig,
  MicrosoftDubberPointsFieldConfig,
  MicrosoftDubberUserFieldConfig,
} from '../models/generated/ziroModels';

@Injectable()
export class DubberFieldConfigResource {
  protected http = inject(HttpClient);

  getComplianceRecordingPolicy(
    tenantId: string | number,
    withRecording: boolean,
  ): Observable<MicrosoftComplianceRecordingPolicyFieldConfig> {
    return this.http.get<MicrosoftComplianceRecordingPolicyFieldConfig>(
      `/services/microsoft/teams-user-management/tenants/${tenantId}/field-configs/compliance-recording-policies?withRecording=${withRecording}`,
    );
  }

  getDubberUserFieldConfig(tenantId: string | number, upn: string): Observable<MicrosoftDubberUserFieldConfig> {
    return this.http.get<MicrosoftDubberUserFieldConfig>(
      `/services/microsoft/teams-user-management/tenants/${tenantId}/field-configs/dubber-users?upn=${encodeURIComponent(upn)}`,
    );
  }

  getDubberPointsFieldConfig(tenantId: string | number): Observable<MicrosoftDubberPointsFieldConfig> {
    return this.http.get<MicrosoftDubberPointsFieldConfig>(
      `/services/microsoft/teams-user-management/tenants/${tenantId}/field-configs/dub-points`,
    );
  }
}
